import { createMemoStyles } from '@wds/utils';

const useStyles = createMemoStyles(() => ({
  navSection: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export default useStyles;
